import { Constants } from '@/constants';
import { i18n } from '@/plugins/i18n';

const AT = Constants.Community.AccountType;

// The account types that hold a customer's data, behind which a superadmin
// needs the customer's request to enter (COCO-3425). The API holds the same
// rule in customerAccessService and enforces it; this copy only lets the admin
// warn before a change that lifts it.
const CUSTOMER_ACCOUNT_TYPES: number[] = [AT.Customer, AT.PastCustomer];

export const isCustomerAccountType = (accountType: number) => CUSTOMER_ACCOUNT_TYPES.includes(accountType);

export const getAccountTypeOptions = () => [
  { label: i18n.global.t('customerOverview.accountType.customer'), value: AT.Customer },
  { label: i18n.global.t('customerOverview.accountType.demo'), value: AT.Demo },
  { label: i18n.global.t('customerOverview.accountType.internal'), value: AT.Internal },
  { label: i18n.global.t('customerOverview.accountType.pastCustomer'), value: AT.PastCustomer },
];
